import React, {useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import SurveysItemBrowser from "./SurveysItemBrowser";
import SurveysItemEditor from "./SurveysItemEditor";

const SurveysBrowseSubPage = ({isAddSubMode, surveyData}) => {

    const [filteredItems, setFilteredItems] = useState([]); // текущие загруженные с сервера (с учетом фильтра) итемы (некоторая их часть - страница)
    const [refsData, setRefsData] = useState({});
    const [editItemId, setEditItemId] = useState(0);
    const [searchByIdMode, setSearchByIdMode] = useState(false);

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {!isAddSubMode && <div className={cl.browserArea} style={undefined}>
                    <SurveysItemBrowser
                        filteredItems={filteredItems}
                        setFilteredItems={setFilteredItems}
                        refsData={refsData}
                        setRefsData={setRefsData}
                        selectedItemId={editItemId}
                        setSelectedItemId={setEditItemId}
                        setSearchByIdMode={setSearchByIdMode}
                    />
                </div>}
                {(isAddSubMode || editItemId !== 0) && <div className={cl.editorArea}>
                    <SurveysItemEditor
                        key={editItemId}
                        surveyData={surveyData}
                        editItemId={editItemId}
                        searchByIdMode={searchByIdMode}
                    />
                </div>}
            </div>
        </div>
    );
};

export default SurveysBrowseSubPage;